var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// libs
import React from 'react';
import { useNavigate } from 'react-router-dom';
// api
import { initiateLogingApi, sendOtp, signInWithOTP } from '@/includes/api/auth';
// constants
import { LOGIN_TYPE } from '@/constants/login';
import Routes from '@/constants/Routes';
import { localStorageKeys } from '@/constants/storage';
import { REQUEST_OTP_LIMIT_REACHED, VERIFY_OTP_LIMIT_REACHED, } from './constants';
//widgets
import OtpInput from '@/pages/instamart/login/widgets/OTPInput';
import EmailInput from '@/pages/instamart/login/widgets/EmailInput';
import SsoLogin from '@/pages/instamart/widgets/SsoLogin';
// styles
import styles from './login.module.scss';
// helpers
import { writeToLocalStorage } from '@/helpers/storage';
export default function LoginPage({ handleLoginSuccess }) {
    const navigate = useNavigate();
    const [showOtpField, setshowOtpField] = React.useState(false);
    const [email, setEmail] = React.useState('');
    const [errorText, setErrorText] = React.useState('');
    const [otpResponse, setOtpResponse] = React.useState({
        sessionInfo: '',
        userId: '',
    });
    const [otpVerifyCount, setOtpVerifyCount] = React.useState(0);
    const [resendOtpCount, setResendOtpCount] = React.useState(0);
    const handleLogin = () => __awaiter(this, void 0, void 0, function* () {
        const redirectURI = yield initiateLogingApi(LOGIN_TYPE.EXTERNAL);
        if (redirectURI) {
            window.location.href = redirectURI;
        }
    });
    const onEmailSubmit = (isResend) => __awaiter(this, void 0, void 0, function* () {
        try {
            setOtpVerifyCount(0);
            if (isResend) {
                if (resendOtpCount >= 3) {
                    setErrorText(REQUEST_OTP_LIMIT_REACHED);
                    return;
                }
            }
            else {
                setResendOtpCount(0);
            }
            const response = yield sendOtp(email);
            response && setOtpResponse(response);
            setshowOtpField(true);
            setErrorText('');
        }
        catch (e) {
            setErrorText(e.message);
        }
        finally {
            isResend &&
                setResendOtpCount((resendOtpCount) => resendOtpCount + 1);
        }
    });
    const onOtpSubmit = (otp) => __awaiter(this, void 0, void 0, function* () {
        try {
            if (otpVerifyCount >= 3) {
                setErrorText(VERIFY_OTP_LIMIT_REACHED);
                return;
            }
            yield signInWithOTP(otp, otpResponse.userId, otpResponse.sessionInfo, () => __awaiter(this, void 0, void 0, function* () {
                handleLoginSuccess(true);
                yield writeToLocalStorage(localStorageKeys.LOGIN_TYPE, LOGIN_TYPE.EXTERNAL);
                navigate(Routes.INSTAMART_HOME, {
                    replace: true,
                    preventScrollReset: true,
                });
            }));
        }
        catch (e) {
            setErrorText(e.message);
        }
        finally {
            setOtpVerifyCount((otpVerifyCount) => otpVerifyCount + 1);
        }
    });
    const onEmailChange = (email) => {
        setErrorText('');
        setEmail(email);
    };
    const onOtpChange = () => {
        setErrorText('');
    };
    const onOtpBack = () => {
        setErrorText('');
        setshowOtpField(false);
    };
    return (React.createElement("div", { className: styles.content },
        !showOtpField && (React.createElement(EmailInput, { onSubmit: onEmailSubmit, onChange: onEmailChange, email: email, errorText: errorText, onSsoLogin: handleLogin })),
        showOtpField && (React.createElement(OtpInput, { onBack: onOtpBack, onSubmit: onOtpSubmit, errorText: errorText, onChange: onOtpChange, onResendOtp: onEmailSubmit, email: email })),
        React.createElement(SsoLogin, { handleLogin: handleLogin })));
}
